import UploadReviewCycleFiles from "../../pages/applications/upload-review-cycle-files";
import {CommentOutlined, LoadingOutlined, UploadOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Button, Input, Modal, Popover, Radio, Space, Spin, Tooltip} from "antd";
import AuthZButton from "../AuthzButton";
import {ApplicationListPageActions, complianceTags} from "../../pages/applications/applicationList/model";
import {isEmptyString, isNullOrUndefinedOrEmpty} from "../../common/utils";
import {DownloadFiles} from "../../pages/applications/download-files";
import {fetchAvailableDownloadsForApplication} from "../../pages/applications/download-files/service";
import {useHistory} from "react-router-dom";
import {Routes} from "../../common/Routes";
import {getLatestFileComments} from "../../pages/applications/applicationList/service";
import {ApplicationDetail, CommentResponse} from "./model";
import {ReviewAction, sendReviewEvent} from "../matomoClient";

const { TextArea } = Input;

export const ReviewActions = ({appDetail}: ApplicationDetail) => {
  const [selectedRadio, setSelectedRadio] = useState<any>(undefined);
  const [fileComment, setFileComment] = useState<string>("");
  const [stateChangeInProgress, setStateChangeInProgress] = useState<boolean>(false);
  const [commentBoxStatus, setCommentBoxStatus] = useState<"error" | "">("");
  const [fileCommentContent, setFileCommentContent] = useState<JSX.Element>(<></>);
  const [newReviewModalState, setNewReviewModalState] = useState<boolean>(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const fileVerificationContent = (
    <div>
      <p>Mark the files as</p>
      <Radio.Group
        size={"small"}
        onChange={(event) => setSelectedRadio(event.target.value)}
      >
        <Space direction="vertical">
          <Radio value={"accepted"}>Accepted</Radio>
          <Radio value={"rejected"}>Rejected</Radio>
        </Space>
      </Radio.Group>
      <p style={{marginTop: "10px", marginBottom: "2px"}}>Comments</p>
      <TextArea
        rows={4}
        onChange={(event) => commentBoxChange(event.target.value)}
        style={{resize: "none"}}
        status={commentBoxStatus}
      />
      {/* @ts-ignore */}
      <AuthZButton
        authZButtonType="primary"
        buttonStyle={{fontSize: "12px", padding: "1px 5px 1px 5px", height: "25px", marginTop: "5px", marginLeft: "0px"}}
        onClick={submitFileVerification}
        ariaLabel={"file-verification-submit"}
      >
        Submit
      </AuthZButton>
    </div>
  );

  const getFileCommentAndUpdateContent = (isPopupVisible: boolean) => {
    if (!isPopupVisible)
      return

    setFileCommentContent(<Spin />);

    getLatestFileComments(appDetail.id).then((response: CommentResponse | null) => {
      let content: JSX.Element;

      if (response)
        content = (
          <div style={{display: "flex", flexDirection: "row", fontSize: "12px"}}>
            <div style={{width: "150px", wordWrap: "break-word", marginRight: "15px"}}>{response.value}</div>
            <div>
              <div>{response.addedOn.split("T")[0]}</div>
              <div>{response.addedBy.fullName}</div>
            </div>
          </div>
        );
      else
        content = (<p>No comments</p>);

      setFileCommentContent(content);
    })
  };

  function commentBoxChange(value: string) {
    setFileComment(value);
    setCommentBoxStatus("");
  }

  function submitFileVerification() {
    if (isEmptyString(fileComment)) {
      setCommentBoxStatus("error");
      return;
    }
    if (isNullOrUndefinedOrEmpty(selectedRadio))
      return;

    const isAccepted = (selectedRadio === "accepted");
    setStateChangeInProgress(true);
    sendReviewEvent(ReviewAction.SubmittedFileVerification, appDetail.name)
    // @ts-ignore
    dispatch(ApplicationListPageActions.submitFileVerification({appId: appDetail.id, isAccepted: isAccepted, comment: fileComment}));
  }

  useEffect(() => {
    setStateChangeInProgress(false);
  }, [appDetail]);

  const reviewActionButtonStyle = {
    fontSize: "10px",
    padding: "1px 5px 1px 5px",
    height: "25px",
    marginLeft: "0px",
    marginRight: "5px"
  }

  if (!appDetail.applicableActions)
    return (<></>);

  if (stateChangeInProgress)
    return (<LoadingOutlined spin/>);
  else
    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        {
          (appDetail.applicableActions.indexOf("NEW_REVIEW") >= 0) ?
            <>
              {/* @ts-ignore */}
              <AuthZButton
                authZButtonType="primary"
                buttonStyle={reviewActionButtonStyle}
                onClick={() => {
                  setNewReviewModalState(true);
                  sendReviewEvent(ReviewAction.OpenNewReviewModal, appDetail.name)
                }}
                ariaLabel={"new-review"}
              >
                New Review
              </AuthZButton>
              <Modal
                visible={newReviewModalState}
                footer={[
                  <>
                    <Button onClick={() => setNewReviewModalState(false)}>Cancel</Button>
                    <Button
                      type={"primary"}
                      aria-label={"new-review-confirm"}
                      onClick={() => {
                        // @ts-ignore
                        dispatch(ApplicationListPageActions.startNewReview(appDetail.id));
                        sendReviewEvent(ReviewAction.NewReviewStarted, appDetail.name)
                        setStateChangeInProgress(true);
                        setNewReviewModalState(false);
                      }}
                    >
                      OK
                    </Button>
                  </>
                ]}
                onCancel={() => setNewReviewModalState(false)}
              >
                <p>Are you sure you want to start a new round of review?</p>
              </Modal>
            </> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("START_REVIEW") >= 0) ?
            // @ts-ignore
            <AuthZButton
              authZButtonType="primary"
              buttonStyle={reviewActionButtonStyle}
              onClick={() => history.push(`${Routes.Applications.path}/${appDetail.uniqueName}?startReview=yes`)}
              ariaLabel={"start-review"}
            >
              Start Review
            </AuthZButton> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("CLOSE_REVIEW") >= 0) ?
            // @ts-ignore
            <AuthZButton
              authZButtonType="primary"
              buttonStyle={reviewActionButtonStyle}
              onClick={() => history.push(`${Routes.Applications.path}/${appDetail.uniqueName}?closeReview=yes`)}
              ariaLabel={"close-review"}
            >
              Close Review
            </AuthZButton> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("CANCEL_REVIEW") >= 0) ?
            // @ts-ignore
            <AuthZButton
              authZButtonType="primary"
              buttonStyle={reviewActionButtonStyle}
              onClick={() => history.push(`${Routes.Applications.path}/${appDetail.uniqueName}?cancelReview=yes`)}
              ariaLabel={"cancel-review"}
            >
              Cancel Review
            </AuthZButton> : <></>
        }
        {
          ((appDetail.applicableActions.indexOf("PASS_VERIFICATION") >= 0) || (appDetail.applicableActions.indexOf("FAIL_VERIFICATION") >= 0)) ?
            <Popover
              placement="bottomRight"
              title={<span style={{fontWeight: 700}}>File Verification</span>}
              trigger="click"
              content={fileVerificationContent}
              onVisibleChange={(isVisible) => {
                  if (isVisible) {
                      sendReviewEvent(ReviewAction.OpenedFileVerificationModal, appDetail.name)
                  }
              }}
            >
              {/* @ts-ignore */}
              <AuthZButton
                authZButtonType="primary"
                buttonStyle={reviewActionButtonStyle}
                ariaLabel={"file-verification"}
              >
                Accept / Reject
              </AuthZButton>
            </Popover> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("UPLOAD_FILES") >= 0) ?
            <UploadReviewCycleFiles
              modalTriggerElement={
                <Tooltip title={"Upload review files"} placement="left">
                  <UploadOutlined
                    style={{
                      fontSize: "18px",
                      color: "#808080",
                      cursor: "pointer",
                      marginRight: "5px"
                    }}
                  />
                </Tooltip>
              }
              appInfo={{
                name: appDetail.name,
                id: appDetail.id,
                hasUploadPermission: appDetail.hasUploadPermission,
              }}
            /> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("DOWNLOAD_FILES") >= 0) ?
              <DownloadFiles
                  appProps={{id: appDetail.id, name: appDetail.name}}
                  reviewProps={null}
                  fetchAvailableDownloadableFiles={fetchAvailableDownloadsForApplication}
                  popoverPlacement="bottomLeft"
                  showOnlyLatestFiles={true}
              /> : <></>
        }
        {
          (appDetail.applicableActions.indexOf("DOWNLOAD_FILES") >= 0 && appDetail.complianceTags.includes(complianceTags.itgc)) ?
            <Popover
              title={<span style={{fontWeight: 700}}>Comments</span>}
              trigger={"click"}
              placement={"bottomLeft"}
              content={fileCommentContent}
              onVisibleChange={(visible) => {
                  getFileCommentAndUpdateContent(visible)
                  if(visible) {
                      sendReviewEvent(ReviewAction.ViewComment, appDetail.name)
                  }
              }}
            >
              <CommentOutlined
                style={{
                  fontSize: "18px",
                  color: "#808080",
                  cursor: "pointer",
                  marginLeft: "5px"
                }}
                aria-label={"file-comment"}
              />
            </Popover> : <></>
        }
      </div>
    );
}
